import { Button, Typography } from "@outschool/backpack";
import React from "react";

interface Props {
  icon: React.ReactNode;
  text: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

const ClassItemActionButton = React.forwardRef(
  (
    { icon, text, onClick, disabled }: Props,
    ref: React.Ref<HTMLButtonElement>
  ) => {
    return (
      <Button
        ref={ref}
        variant="text"
        onClick={onClick}
        disabled={disabled}
        sx={{
          gap: 6,
          padding: 0,
          backgroundColor: "transparent !important",
          "&:disabled": {
            opacity: 0.3
          }
        }}
      >
        {icon}
        <Typography variant="button" sx={{ color: "primary.main" }}>
          {text}
        </Typography>
      </Button>
    );
  }
);

export default ClassItemActionButton;
